/* ecomify.net homepage theme slider: arrows scroll one card, the counter follows the first visible card. */
class ThemeSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.cards = [...this.track.children];
    this.prev = this.querySelector('[data-prev]');
    this.next = this.querySelector('[data-next]');
    this.current = this.querySelector('[data-current]');
    this.prev.addEventListener('click', () => this.go(-1));
    this.next.addEventListener('click', () => this.go(1));
    this.track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
    });
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    this.update();
  }

  index() {
    const left = this.track.scrollLeft;
    let best = 0;
    this.cards.forEach((card, i) => {
      if (Math.abs(card.offsetLeft - this.track.offsetLeft - left) < Math.abs(this.cards[best].offsetLeft - this.track.offsetLeft - left)) best = i;
    });
    return best;
  }

  go(step) {
    const i = Math.max(0, Math.min(this.cards.length - 1, this.index() + step));
    this.track.scrollTo({ left: this.cards[i].offsetLeft - this.track.offsetLeft });
  }

  update() {
    const i = this.index();
    this.current.textContent = String(i + 1).padStart(2, '0');
    const max = this.track.scrollWidth - this.track.clientWidth - 2;
    this.prev.disabled = this.track.scrollLeft <= 2;
    this.next.disabled = this.track.scrollLeft >= max;
  }
}
customElements.define('theme-slider', ThemeSlider);
